import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initErrorReporter } from "@/lib/errorReporter";

initErrorReporter();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Dismiss the boot splash defined in /public/index.html once React has mounted.
// We wait a frame so the first paint is in place, then fade-out + remove.
requestAnimationFrame(() => {
  const splash = document.getElementById("kingly-splash");
  if (!splash) return;
  // Tiny minimum on-screen time so it doesn't flicker on fast loads.
  setTimeout(() => {
    splash.classList.add("is-leaving");
    setTimeout(() => splash.remove(), 350);
  }, 250);
});
